import { IParamsCreateFileObject } from '@/courses/interfaces/params-create-file-object.interface';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Mixins, Prop, Watch } from 'vue-property-decorator';
import KEYS from '@/values/keys';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { required, maxLength } from 'vuelidate/lib/validators'
import { SECTION_TYPES } from '@/content/values/sections';
import { IResultCreateFileObject } from '@/courses/interfaces/result-create-file-object.interface';
import { SectionMixin } from '@/courses/mixins/section.mixin';
import ToolService from '@/providers/tools';
import { CreateObjectsMixin } from '@/courses/mixins/create-objects.mixin';

@Component({
  components: {
    EdSelectTag: () => import(/* EdSelectTag */'@/courses/components/ed-select-tag/ed-select-tag.component.vue')
  }
})
export default class EdCreateOtherFilesObject extends Mixins(SectionMixin, CreateObjectsMixin) {

  //@Prop() readonly params: IParamsCreateFileObject;     //Typescript upgrade
  declare readonly params: IParamsCreateFileObject;
  @Prop() readonly close: Function;
  @Prop() readonly save: Function;

  public dropzoneMode = KEYS.DROPZONE_CONFIG.SINGLE;
  public dropzoneOptions: any = {
    url: 'http://eduac.com',
    autoProcessQueue: false,
    addRemoveLinks: true,
    uploadMultiple: false,
    maxFiles: 1,
    parallelUploads: 1,
    createImageThumbnails: false,
    maxFilesize: 200,
    timeout: 600000
  };
  public form: any = null;
  public type: string = SECTION_TYPES.LESSON_OTHER_FILE.code;
  public file: any = null;
  public saving: boolean = false;
  public ext: string = '';
  public hasErrorFile: boolean = false;
  public removingFile: boolean = false;
  public fileAdded: boolean = false;
  public otherExtensions: string = '';
  public tags: Array<string> = ['TEST', 'CLASSWORK', 'HOMEWORK'];
  public tagSelected: string = '';

  get title() {
    return this.params.title;
  }

  get edition() {
    return this.params.edition;
  }

  get preload() {
    return this.params.preload;
  }

  get hasDropzone() {
    return !this.file;
  }

  get escapedName() {
    return ToolService.exitSpecialChars(this.form.name.value);
  }


  initForm(name: string = '') {
    this.form = EdFormModel([
      EdInputModel('name', name, { required, maxLength: maxLength(60) }),
    ]);
  }

  onFileAdd(file: any) {
    this.hasErrorFile = false;
    setTimeout(() => {
      if(file.accepted) {
        this.ext = this.getExtension(file.name);
        if(this.$store.state.AppStore.fileExtensionsNotAllowed.includes('.' + this.ext)) {
          this.showModalErrorByMessage('editOtherFileExtensionNotAllowedError');
          this.removeFile();  
        } else {
          this.file = file;
          if(!this.form.get('name').value) this.setFileName(file.name);
          this.fileAdded = true;
        }
        
      }
    }, 0);
  }

  setFileName(filename: string) {
    let nameParts = filename.split('.');
    let name = filename.replace(
      `.${nameParts[nameParts.length - 1]}`,
      ''
    ).slice(0, 60);
    Vue.set(this.form, 'name', {
      valid: true,
      validators: { required, maxLength: maxLength(60) },
      value: name
    });
  }

  getExtension(filename) {
    let fileArr = filename.split('.');
    return fileArr[fileArr.length - 1] ? fileArr[fileArr.length - 1] : '';
  }

  onErrorFile() {
    this.hasErrorFile = true;
    this.removeFile();
  }

  removeFile() {
    let refs: any = this.$refs;
    refs.dropzoneRef.removeAllFiles();
    this.file = null;
  }

  created() {
    let msg = String(this.$i18n.t('courses.lesson.editOtherFileDisclamer'));
    this.otherExtensions = msg.replace('{{otherExtensions}}', String(this.$store.state.AppStore.fileExtensionsNotAllowed.join(', ')));

    if(this.edition || this.preload) {
      this.file = this.params.file;
      this.ext = this.params.ext;
      this.tagSelected = this.params.labelSections;

      this.initForm(
        this.params.name
      );

      if(this.params.component) {
        this.componentSelected = this.components.find(c => c.id == this.params.component.id);
      } else if(this.components) {
        this.componentSelected = this.components.find(c => c.mandatory);
      }
    } else {
      this.initForm();
      if(this.course.eduacComponents) {
        this.componentSelected = this.components.find(c => c.mandatory);
      }
    }
  }

  closeModal() {
    this.$emit('close');
  }

  setDateToSave() {
    this.saveFile({
      dueDate: null,
      homework: false,
      name: this.form.name.value,
      file: this.file,
      fileAdded: this.fileAdded,
      type: this.type,
      ext: this.ext,
      ...this.dueDateInfo,
      labelSections: this.tagSelected,
      component: this.componentSelected
    });
  }

  setSaving(value: boolean) {
    this.saving = value;
  }

  saveFile(fileObject: IResultCreateFileObject) {
    this.$emit('save', fileObject);
  }

  showModalErrorByMessage(message: string) {
    this.$EdModal.createMessageModal({
      title: this.$i18n.t('courses.errors.errorTitle'),
      body: this.$i18n.t(`courses.errors.${message}`),
      type: KEYS.EVENT_TYPES.DANGER
    });
  }

}